import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Screen from '../components/common/Screen';
import NavBar from '../components/common/NavBar';
import SupportBar from '../components/common/SupportBar';
import { handleSessionRedirect } from '../utils';
import { useNavigate } from 'react-router-dom';

const Base = ({ children, activeNav, color }) => {
  const navigate = useNavigate();

  useEffect(() => {
  handleSessionRedirect(navigate);
}, [navigate]);
  return (
    <Screen color={color} >
      <div className="top">
        <SupportBar />
        {children}
      </div>
      <div className="bottom">
        <NavBar active={activeNav} />
      </div>
    </Screen>
  );
};

export default Base;